import React from 'react';
import classNames from 'classnames';
import { getContext } from '@fiverr-private/fiverr_context';
import { Carousel } from '@fiverr-private/orca';
import { SCROLL_TYPE } from '@fiverr-private/orca/dist/src/components/Carousel/constants';
import type { TilesCarouselType } from '@fiverr-private/listing_types';
import { CarouselNavigation } from './carousel_navigation';
import './index.scss';

export const TilesCarousel: React.FC<TilesCarouselType> = ({
    items = [],
    TileComponent,
    onArrowClick,
    tilePadding = 0,
    maxTilesToShow = 4,
    className,
    breakpoints,
    autoSlidesWidth = true,
    hideDefaultArrows = true,
    arrowsClassName = '',
}) => {
    const { isTouch } = getContext();

    const [canScrollLeft, setCanScrollLeft] = React.useState(false);
    const [canScrollRight, setCanScrollRight] = React.useState(items.length >= maxTilesToShow);

    const navigationRef = React.useRef({});
    const shouldDisplayNavigation = !isTouch && (canScrollRight || canScrollLeft);

    const onScroll = ({ canScrollRight, canScrollLeft }: { canScrollRight: boolean; canScrollLeft: boolean }) => {
        setCanScrollRight(canScrollRight);
        setCanScrollLeft(canScrollLeft);
    };

    if (!items.length) return null;

    const carouselClassName = classNames('tiles-carousel', className, {
        'mobile-slider': isTouch,
        'fade-right': canScrollRight,
        'fade-left': canScrollLeft,
    });

    return (
        <div className={carouselClassName}>
            <CarouselNavigation
                shouldDisplayNavigation={shouldDisplayNavigation}
                navigationRef={navigationRef}
                canScrollLeft={canScrollLeft}
                canScrollRight={canScrollRight}
            />
            <Carousel
                slides={items}
                breakpoints={breakpoints}
                swipeMode={isTouch}
                slidesToShow={maxTilesToShow}
                Component={TileComponent}
                onArrowClick={onArrowClick}
                scrollType={SCROLL_TYPE.ROW}
                slidePadding={tilePadding}
                onScroll={onScroll}
                navigationRef={navigationRef}
                isInfinite={false}
                arrowsClassName={arrowsClassName}
                autoSlidesWidth={autoSlidesWidth}
                hideDefaultArrows={hideDefaultArrows}
            />
        </div>
    );
};
